import { getEventLog } from '@lib/api/eventlogs'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppThunk } from '@state/store'
import { AxiosInstance } from 'axios'

interface eventLogState {
  list: {
    data: any
    loading: boolean
    isLoaded: boolean
    error: any
  }
}

const initialState: eventLogState = {
  list: {
    data: [],
    loading: false,
    isLoaded: false,
    error: '',
  },
}

const eventLog = createSlice({
  name: 'eventLog',
  initialState,
  reducers: {
    getEventLogStart(state) {
      state.list.loading = true
    },
    getEventLogSuccess(state, action: PayloadAction) {
      state.list.data = action.payload
      state.list.loading = false
      state.list.isLoaded = true
    },
    getEventLogFailure(state, action: PayloadAction<string>) {
      state.list.loading = false
      state.list.isLoaded = false
      state.list.error = action.payload
      console.log(action.payload)
    },
    clearEventLogSuccess(state) {
      ;((state.list.data = []), (state.list.loading = false), (state.list.isLoaded = false), (state.list.error = ''))
    },
  },
})

export const { getEventLogStart, getEventLogSuccess, getEventLogFailure, clearEventLogSuccess } = eventLog.actions

export default eventLog.reducer

export const fetchEventLog =
  (api:AxiosInstance,deviceId: string): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(getEventLogStart())
      const eventLogList = await getEventLog(api,deviceId)
      dispatch(getEventLogSuccess(eventLogList))
    } catch (err: any) {
      dispatch(getEventLogFailure(err?.message))
    }
  }
